import { useContext } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ColorModeContext } from '../contexts/ColorModeContext';
import { palette, theme } from '../theme/colors';

interface ProductSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const ProductSearch = ({
  value,
  onChange,
  placeholder = 'Search products...'
}: ProductSearchProps) => {
  const { mode } = useContext(ColorModeContext);

  const colors = mode === 'dark' ? {
    bg: palette.background,
    surface: palette.surface,
    surfaceElevated: palette.surfaceElevated,
    surfaceHover: palette.surfaceHover,
    border: palette.border,
    borderLight: palette.borderLight,
    textPrimary: palette.textPrimary,
    textSecondary: palette.textSecondary,
    textMuted: palette.textMuted,
  } : {
    bg: palette.light.background,
    surface: palette.light.surface,
    surfaceElevated: palette.light.surfaceElevated,
    surfaceHover: palette.light.surfaceHover,
    border: palette.light.border,
    borderLight: palette.light.borderLight,
    textPrimary: palette.light.textPrimary,
    textSecondary: palette.light.textSecondary,
    textMuted: palette.light.textMuted,
  };

  return (
    <TextField
      fullWidth
      variant="outlined"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: colors.textMuted, fontSize: 20 }} />
          </InputAdornment>
        ),
      }}
      sx={{
        maxWidth: { xs: '100%', sm: 400 },
        '& .MuiOutlinedInput-root': {
          backgroundColor: colors.surface,
          borderRadius: theme.radius.md,
          fontSize: '0.875rem',
          transition: theme.transitions.fast,
          '& fieldset': {
            borderColor: colors.border,
          },
          '&:hover fieldset': {
            borderColor: colors.borderLight,
          },
          '&.Mui-focused fieldset': {
            borderColor: palette.primary,
            borderWidth: '1px',
          },
        },
        '& .MuiOutlinedInput-input': {
          color: colors.textPrimary,
          padding: '10px 14px 10px 0',
          '&::placeholder': {
            color: colors.textMuted,
            opacity: 1,
          },
        },
      }}
    />
  );
};
